export enum ToolbarOptions {
  TextStyle = 'textStyle',
  Bold = 'bold',
  Italic = 'italic',
  Underline = 'underline',
  Strike = 'strike',
  List = 'list',
  BulletList = 'bulletList',
  OrderedList = 'orderedList',
  Align = 'align',
  AlignLeft = 'left',
  AlignCenter = 'center',
  AlignRight = 'right',
  AlignJustify = 'justify',
  FullScreenOn='fullScreenOn',
  FullScreenOff='fullScreenOff',
}

export type BoxType = ToolbarOptions.Align | ToolbarOptions.List | ToolbarOptions.TextStyle;

export type ToolbarItemType = {
  label: string,
  onClick: () => boolean,
  icon: string,
}

export type ToolbarItemsType = Record<ToolbarOptions, ToolbarItemType>;
